import { AnimatePresence, motion } from "framer-motion";
import Image from "@/components/Image";
import React, { useImperativeHandle, useState, forwardRef } from "react";

export interface DiamondFloatRef {
  play: () => void;
}

interface DiamondFloatProps {
  exp: number | string;
  color?: string;
  className?: string;
  duration?: number; // 动画持续时间（ms）
}

const DiamondFloat = forwardRef<DiamondFloatRef, DiamondFloatProps>(
  ({ exp, color = "#FCE353", className, duration = 800 }, ref) => {
    const [visible, setVisible] = useState(false);

    useImperativeHandle(ref, () => ({
      play: () => {
        setVisible(true);
        setTimeout(() => setVisible(false), duration);
      }
    }), [duration]);

    return (
      <AnimatePresence>
        {visible && (
          <motion.div
            className={`absolute z-10 flex flex-row items-center gap-2 ${className || ""}`}
            initial={{ opacity: 0.8, y: 40 }}
            animate={{ opacity: 0.8, y: 0 }}
            exit={{ opacity: 0.2, y: -40 }}
            transition={{ duration: duration / 1000 }}
          >
            <div className="text-[10rem] font-bold" style={{ color }}>{`+${exp}`}</div>
            <Image src={'/assets/diamond-3.png'} alt={'diamond2'} width={128} height={128}/>
          </motion.div>
        )}
      </AnimatePresence>
    );
  }
);

DiamondFloat.displayName = "DiamondFloat";
export default DiamondFloat;
